<template>
  <sub-page :title="title">
    <div class="graduate-page">
      <div class="dialog-mask" v-if="showDialog">
        <div class="dialog-box">
          <div class="dialog-title">提示</div>
          <div class="dialog-content">该功能需要进行二次认证</div>
          <div class="dialog-btns">
            <button class="dialog-btn cancel" @click="showDialog = false">稍后去认证</button>
            <button class="dialog-btn confirm" @click="handleConfirm">现在去认证</button>
          </div>
        </div>
      </div>
      <div class="empty-content" v-else>
        <div class="empty-text">功能建设中，敬请期待</div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'Graduate',
  components: { SubPage },
  data() {
    return {
      title: '毕业生就业掌上宝',
      showDialog: true
    }
  },
  methods: {
    handleConfirm() {
      this.showDialog = false
    }
  }
}
</script>

<style scoped>
.graduate-page {
  background: #F3F8FB;
  min-height: 100%;
}
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}
.dialog-box {
  width: 80%;
  background: #fff;
  border-radius: calc(16 * var(--w));
  overflow: hidden;
}
.dialog-title {
  padding: calc(48 * var(--w)) 0 calc(16 * var(--w));
  text-align: center;
  font-size: calc(40 * var(--w));
  font-weight: 500;
  color: #323233;
}
.dialog-content {
  padding: 0 calc(48 * var(--w)) calc(48 * var(--w));
  text-align: center;
  font-size: calc(32 * var(--w));
  color: #323233;
}
.dialog-btns {
  display: flex;
  border-top: 1px solid #f0f0f0;
}
.dialog-btn {
  flex: 1;
  height: calc(96 * var(--w));
  font-size: calc(32 * var(--w));
  border: none;
  background: #fff;
  cursor: pointer;
}
.dialog-btn.cancel {
  color: #f28100;
  border-right: 1px solid #f0f0f0;
}
.dialog-btn.confirm {
  color: #2E8CF6;
}
.empty-content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}
.empty-text {
  font-size: calc(32 * var(--w));
  color: #969799;
}
</style>



// WEBPACK FOOTER //
// src/pages/Graduate.vue